import { Box, Grid, Paper } from "@material-ui/core";
import ParentComponent from "./ParentComponent";
import { styled } from '@mui/material/styles';
import { useDispatch } from "react-redux";
import { getPersonalitySaboteur } from "../../../../Redux/Reducers/numerologyReducer";
import { useEffect } from "react";
import { SABOTEUR_DESCRIPTIONS } from '../../../../config/SABOTEUR_DESCRIPTIONS';
import { Typography } from "@mui/material";
import { Height } from "@mui/icons-material";
import { useSelector } from "react-redux";
import CompleteTexsticon from '../../../../Assets/img/verified.png';
import {
    buildStyles,
    CircularProgressbarWithChildren,
} from "react-circular-progressbar";

import Images from '../../../../Assets/img/ImageUtilities';

const PersonalitySaboteur = () => {
    const dispatch = useDispatch();
    const handlesaboteur = async () => {
        try {
            const response = await dispatch(getPersonalitySaboteur());
            console.log("REsponse------------", response);
        } catch (error) {
            console.log("API ERROR", error);
        }
    };

    const data = useSelector((state) => state?.numerology?.saboteurresult);
    console.log("Saboteur---------", data);

    const result = [
        { "value": data?.judge, "ImgName": Images?.Judge, "Role": "Judge" },
        { "value": data?.controller, "ImgName": Images?.Controller, "Role": "Controller" },
        { "value": data?.stickler, "ImgName": Images?.Stickler, "Role": "Stickler" },
        { "value": data?.pleaser, "ImgName": Images?.Pleaser, "Role": "Pleaser" },
        { "value": data?.hyper_achiever, "ImgName": Images?.Hyper_Achiever, "Role": "Hyper-Achiever" },
        { "value": data?.hyper_rational, "ImgName": Images?.Hyper_Rational, "Role": "Hyper-Rational" },
        { "value": data?.hyper_vigilant, "ImgName": Images?.Hyper_vigilant, "Role": "Hyper-Vigilant" },
        { "value": data?.restless, "ImgName": Images?.Restless, "Role": "Restless" },
        { "value": data?.avoider, "ImgName": Images?.Avoider, "Role": "Avoider" },
        { "value": data?.victim, "ImgName": Images?.Victim, "Role": "Victim" }
    ];

    const imageNames = result.map(item => item.ImgName);
    console.log("mapped values---------", imageNames);


    const saboteurs = SABOTEUR_DESCRIPTIONS;
    useEffect(() => {
        handlesaboteur();
    }, []);

    return (
        <ParentComponent>

            {data === null ? 
            <div className="d-flex flex-column align-items-center justify-content-center pt-5">
                <img src={CompleteTexsticon} alt="Images" width="10%" height="10%"/>
                <h4 className="fw-semibold">Please complete your Personality test</h4>
            </div>
             : <div
                className="px-2 d-flex flex-column align-items-start"
                style={{
                    maxHeight: '600px',
                    overflowY: 'auto',
                    scrollbarWidth: "none",

                    // width: "80%",
                }}>
                <h3 className="fw-bold py-2 ps-3">Personality Saboteur</h3>

                <div className="container">
                    <div className="row">
                        {Object.entries(SABOTEUR_DESCRIPTIONS).map(([key, saboteur]) => (
                            <div className="col-sm-4 mb-4" key={key}>
                                <div className="flip-card">
                                    <div className="flip-card-inner">
                                        <div className="flip-card-front">
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                {(() => {
                                                    const match = result?.find(obj => obj?.Role === saboteur?.title);
                                                    if (match) {
                                                        return (
                                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                                {/* Show only the matched image */}
                                                                <div style={{ textAlign: "center", margin: 10 }}>
                                                                    <img
                                                                        src={match?.ImgName}
                                                                        alt={match?.Role}
                                                                        style={{ width: 100, height: 100 }}
                                                                    />
                                                                </div>
                                                                <h5 className="fw-bold m-0">{saboteur?.title}</h5>
                                                                <span className="fw-semibold" style={{ fontSize: "12px" }}>{match?.value}/100</span>
                                                                <div className="personality-probar my-2 mt-3" style={{ width: "20%" }}>
                                                                    {/* Progress bar */}
                                                                    <CircularProgressbarWithChildren
                                                                        className="profile-completion-bar"
                                                                        value={match?.value}
                                                                        styles={buildStyles({
                                                                            pathColor: "#0044c6",
                                                                            trailColor: "#3778f0ff",
                                                                            textColor: "#333",
                                                                            textSize: "10px",
                                                                        })}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                fontSize: "12px",
                                                                                fontWeight: "bold",
                                                                                color: "#000000",
                                                                            }}
                                                                        >
                                                                            {match?.value}%
                                                                        </div>
                                                                    </CircularProgressbarWithChildren>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })()}

                                            </div>

                                        </div>
                                        <div className="flip-card-back">
                                            <h6 className="fw-bold">Pattern and Origin</h6>
                                            <span>{saboteur?.pattern}</span>

                                            <h6 className="fw-bold">Impact</h6>
                                            <span>{saboteur?.impact}</span>

                                            <h6 className="fw-bold">How to Neutralize</h6>
                                            <span>{saboteur?.howToNeutralize}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>}
           

        </ParentComponent>
    );
};

export default PersonalitySaboteur;